import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/1b081d7b-7af8-4f41-a2a3-3a96c65e2238";
export const REGISTER_URL = "https://a.ntrk2.com/170be040-b106-403a-8b60-16b2116f738e";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://hitpe.kzw2a.com/download?openExternalBrowser=1&id=ur3xu5etq411q1j";

export * from "./codes";
export * from "./context";
